import { Collapse, Skeleton } from "@/atoms"

import styles from "./common.module.scss"

export const SkeletonHighProfileVulnerability = () => (
  <Collapse
    className={styles.collapse}
    expandIconPlacement="end"
    collapsible="disabled"
    items={[
      {
        key: "skeleton",
        label: (
          <div className={styles.skeletonContainer}>
            <Skeleton.Input active block size="small" />
            <Skeleton.Button active size="small" />
          </div>
        )
      }
    ]}
  />
)
